import React, {Component} from 'react';
import axios from 'axios';
import {FaCloud} from "react-icons/fa";
import { connect } from 'react-redux';
import {Alert} from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Card, CardBody, Row } from 'reactstrap';
import InputSpinner from "react-bootstrap-input-spinner";
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";

class OrderVpsUsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            product: [],
            error: false,
            messageError: '',
            errorForm: false,
            messageErrorForm: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            groupUserId: 0,
            action: '',
            isSpinner: false,
            special: true,
            actionKey: 0,
            listOs: [],
            listState: [],
            listAddon: { error: 1 },
            configBilling: {
                'monthly' : '1 Tháng',
                'twomonthly' : '2 Tháng',
                'quarterly' : '3 Tháng',
                'semi_annually' : '6 Tháng',
                'annually' : '1 Năm',
                'biennially' : '2 Năm',
                'triennially' : '3 Năm',
                'one_time_pay' : 'Vĩnh viễn',
                'free' : 'Miễn phí',
            },
            os: 0,
            state: '',
            billingCycle: this.props.billcycle,
            listBillingCycle: [],
            qtt: 1,
            addonCpu: 0,
            addonRam: 0,
            addonDisk: 0,
            btnSubmit: true,
        }
    }

     componentDidMount() {
         document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        window.scrollTo(0, 0);
        this.getProductById(this.props.productId, this.props.billcycle);
        this.loadPricing();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if (this.props.isNotification) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getProductById = (productId, billcycle) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = '?productId=' + productId + '&billingCycle=' + billcycle;

        axios.get( process.env.REACT_APP_API_URL + '/api/product/getProduct' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    let osDefault = 13;
                    ref.data.listOs.forEach(osSystem => {
                        if (osSystem.active)
                        {
                            osDefault = osSystem.id;
                        }
                    })

                    this.setState({
                        product: ref.data.product,
                        listOs: ref.data.listOs,
                        listState: ref.data.listState,
                        os: osDefault,
                        state: ref.data.listState[0].name,
                        special: ref.data.special,
                        listAddon: ref.data.listAddon,
                        listBillingCycle: ref.data.listBillingCycle,
                        // billingCycle: ref.data.listBillingCycle[0].value,
                        billingCycle: this.state.billingCycle ? this.state.billingCycle : ref.data.listBillingCycle[0].value,
                        btnSubmit: false,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                })
            })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    loadConfig  = () => {
        if ( Object.keys(this.state.product).length ) {
            return (
                <>
                    Memory: { this.state.product.product_detail.ram } <br/>
                    Disk SSD: { this.state.product.product_detail.disk } <br/>
                    IP: { this.state.product.product_detail.ip } IP public <br/>
                    Hệ điều hành: { this.state.product.product_detail.os } <br/>
                    Băng thông: { this.state.product.product_detail.bandwidth } <br/>
                    {
                        this.state.special ? (
                            <div className="text-danger">
                                <strong>Ghi chú: </strong>Không áp dụng nâng cấp cấu hình với các gói đặc biệt <br/>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                </>
            )
        }
    }

    changeInput = async (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        await this.setState({
            [name]: value
        });
        if ( name === 'billingCycle' || name === 'qtt' ) {
            await this.loadPricing();
        }
    }

    changeAddonCpu = async (num) => {
        if (!this.state.listAddon.error) {
            await this.setState({
                addonCpu: num
            })
            await this.loadPricing();
        }
    }

    changeAddonRam = async (num) => {
        if (!this.state.listAddon.error) {
            await this.setState({
                addonRam: num
            })
            await this.loadPricing();
        }
    }

    changeAddonDisk = async (num) => {
        if (!this.state.listAddon.error) {
            await this.setState({
                addonDisk: num
            })
            await this.loadPricing();
        }
    }

    loadAddonVps = () => {
         if ( !this.state.listAddon.error ) {
             return (
                 <div className="form-group addon-product mt-4 mb-4">
                     <label htmlFor="addon">Chọn gói Addon</label>
                     <div className="row">
                         <div className="col-md-4 addon text-center">
                             <label>CPU</label>
                             {
                                 Object.keys(this.state.listAddon.addonCpu).length ? (
                                     <>
                                         <InputSpinner
                                             type={'int'}
                                             precision={2}
                                             max={20}
                                             min={0}
                                             step={1}
                                             value={0}
                                             onChange={ (num) =>  this.changeAddonCpu(num) }
                                             variant={'primary'}
                                             // size="sm"
                                         />
                                     </>
                                 ) : (
                                     <></>
                                 )
                             }
                         </div>
                         <div className="col-md-4 addon text-center">
                             <label>RAM</label>
                             {
                                 Object.keys(this.state.listAddon.addonRam).length ? (
                                     <>
                                         <InputSpinner
                                             type={'int'}
                                             precision={2}
                                             max={20}
                                             min={0}
                                             step={1}
                                             value={0}
                                             onChange={ (num) =>  this.changeAddonRam(num) }
                                             variant={'primary'}
                                             // size="sm"
                                         />
                                     </>
                                 ) : (
                                     <></>
                                 )
                             }
                         </div>
                         <div className="col-md-4 addon text-center">
                             <label>DISK</label>
                             {
                                 Object.keys(this.state.listAddon.addonDisk).length ? (
                                     <>
                                         <InputSpinner
                                             type={'int'}
                                             precision={2}
                                             max={200}
                                             min={0}
                                             step={10}
                                             value={0}
                                             onChange={ (num) =>  this.changeAddonDisk(num) }
                                             variant={'primary'}
                                             // size="sm"
                                         />
                                     </>
                                 ) : (
                                     <></>
                                 )
                             }
                         </div>
                     </div>
                 </div>
             )
         }
    }

    loadPricing = () => {
        if ( Object.keys(this.state.product).length ) {
            // console.log(this.state.listAddon.addonCpu)
            let product = this.state.product;
            let pricing = product.product_pricing[ this.state.billingCycle ];
            let pricingAddonRam = 0;
            let pricingAddonCpu = 0;
            let pricingAddonDisk = 0;
            product.pricingProduct = pricing;
            // sub total
            if ( !this.state.special && !this.state.listAddon.error ) {
                if ( this.state.addonRam || this.state.addonCpu || this.state.addonDisk ) {
                    if (Object.keys(this.state.listAddon.addonCpu).length) {
                        pricingAddonCpu = this.state.addonCpu * this.state.listAddon.addonCpu.product_pricing[ this.state.billingCycle ];
                    }
                    if (Object.keys(this.state.listAddon.addonRam).length) {
                        pricingAddonRam = this.state.addonRam * this.state.listAddon.addonRam.product_pricing[ this.state.billingCycle ];
                    }
                    if (Object.keys(this.state.listAddon.addonDisk).length) {
                        pricingAddonDisk = this.state.addonDisk * this.state.listAddon.addonDisk.product_pricing[ this.state.billingCycle ] / 10;
                    }
                }
            }
            product.sub_total = pricing + pricingAddonCpu + pricingAddonRam + pricingAddonDisk;
            this.setState({
                product: product
            })
        }
    }

    submit = () => {
        this.setState({
            btnSubmit: true,
        })
        if ( this.validate() ) {
            this.setState({
                loadPage: true,
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                productId: this.props.productId,
                billingCycle: this.state.billingCycle,
                qtt: this.state.qtt,
                os: this.state.os,
                state: this.state.state,
                addonCpu: this.state.addonCpu,
                addonRam: this.state.addonRam,
                addonDisk: this.state.addonDisk,
            };
            // console.log(form);
            axios.post( process.env.REACT_APP_API_URL + '/api/order/createOrderVpsUs', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if (ref.data.error === 0) {
                    	this.props.notification({
				            isNotification: true,
				            textNotification: ref.data.message
				        });
                        this.redirect( ref.data.orderId );
                    } else {
                        if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                btnSubmit: false,
                                errorForm: true,
                                messageErrorForm: ref.data.message,
                                loadPage: false,
                                isLoading: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        btnSubmit: false,
                        loadPage: false,
                        isLoading: false,
                        errorForm: true,
                        messageErrorForm: 'Tạo đơn đặt hàng thất bại',
                    })
                })
        }
    }

    validate = () => {
        if ( !this.state.product.id ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Sản phẩm không tồn tại'
            })
            return false;
        }
        else if ( !this.state.billingCycle.length ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Thời gian thuê không tồn tại'
            })
            return false;
        }
        else if ( typeof this.state.configBilling[ this.state.billingCycle ] === 'undefined' ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Thời gian thuê không có trong dữ liệu'
            })
            return false;
        }
        else if ( this.state.qtt < 1 || this.state.qtt > 20 ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Số lượng không được nhỏ hơn 1 hoặc lớn hơn 50'
            })
            return false;
        }
        else if ( !this.state.os ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Hệ điều hành không được để trống'
            })
            return false;
        }
        return true;
    }

    redirect = (orderId) => {
        this.props.shouldRedirect(orderId);
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Đặt hàng VPS US"} page={"Vps US"} icon={<FaCloud className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        <div className='text-center'>
                                            { this.state.messageError }
                                        </div>
                                    </Alert>
                                ) : (
                                    <Card>
                                        <CardBody>
                                            <Row>
                                                {
                                                    this.state.errorForm ? (
                                                        <div className="col-12 col-lg-12">
                                                            <Alert color="danger">
                                                                { this.state.messageErrorForm }
                                                            </Alert>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <div className="col-12 col-lg-7">
                                                    <div className="product-info rounded">
                                                        <p className="product-title">
                                                            { this.state.product.name }
                                                        </p>
                                                        <p className="config-product">
                                                            {
                                                                this.loadConfig()
                                                            }
                                                        </p>
                                                    </div>

                                                    {/* { */}
                                                    {/*     !this.state.special ? ( */}
                                                    {/*         <> */}
                                                    {/*             { */}
                                                    {/*                 this.loadAddonVps() */}
                                                    {/*             } */}
                                                    {/*         </> */}
                                                    {/*     ) : ( */}
                                                    {/*         <></> */}
                                                    {/*     ) */}
                                                    {/* } */}

                                                    {
                                                        this.state.listOs.length ? (
                                                            <div className="form-group">
                                                                <label htmlFor="os">Hệ điều hành</label>
                                                                <select name="os" className="form-control" id="os" defaultValue={ this.state.os } onChange={ this.changeInput }>
                                                                    {
                                                                        this.state.listOs.map( (os,key) => (
                                                                            <option value={ os.id } key={key}>{ os.os }</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                    {
                                                        this.state.product.type === 'VPS-US' ? (
                                                            this.state.listState.length ? (
                                                                <div className="form-group">
                                                                    <label htmlFor="state">Bang</label>
                                                                    <select name="state" className="form-control" id="state" defaultValue={ this.state.listState[0].name } onChange={ this.changeInput }>
                                                                        {
                                                                            this.state.listState.map( (stateUs,key) => (
                                                                                <option value={ stateUs.name } key={key}>{ stateUs.name }</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                </div>
                                                <div className="col-12 col-lg-5">
                                                    {
                                                        this.state.listBillingCycle.length ? (
                                                            <div className="form-group">
                                                                <label htmlFor="billingCycle">Thời gian thuê</label>
                                                                <select name="billingCycle" className="form-control" id="billingCycle"
                                                                        // defaultValue={ this.state.listBillingCycle[0].value } onChange={ this.changeInput }
                                                                        defaultValue={ this.state.billingCycle } onChange={ this.changeInput }
                                                                >
                                                                    {
                                                                        this.state.listBillingCycle.map( (billingCycle,key) => (
                                                                            <option value={ billingCycle.value } key={key}>{ billingCycle.text_pricing }</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                    <div className="form-group">
                                                        <label htmlFor="qtt">Số lượng</label>
                                                        <input type="number" min={1} max={20} className="form-control"
                                                               name="qtt" id="qtt" value={ this.state.qtt } onChange={ this.changeInput } />
                                                    </div>
                                                    <div className="detail-order">
                                                        <div className="title-detail-order">
                                                            Tóm tắt đơn hàng
                                                        </div>
                                                        <div className="order-summary">
                                                            <div className="order-summary-product">
                                                                <div className="item">
                                                                    <div className="itemtitle">
                                                                        { this.state.product.name }
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col col-md-6 item_billing">
                                                                            { this.state.configBilling[ this.state.billingCycle ] }
                                                                        </div>
                                                                        <div className="col col-md-6 item_pricing text-right">
                                                                            { this.addCommas( this.state.product.pricingProduct ) } ₫
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="addon-item-cpu">
                                                                {
                                                                    !this.state.special && this.state.addonCpu ? (
                                                                        <div className="item">
                                                                            <div className="itemtitle">
                                                                                { this.state.listAddon.addonCpu.name }
                                                                            </div>
                                                                            <div className="row">
                                                                                <div className="col col-md-6 item_billing">
                                                                                    { this.state.addonCpu  } Cores
                                                                                </div>
                                                                                <div className="col col-md-6 item_pricing text-right">
                                                                                    { this.addCommas( this.state.addonCpu * this.state.listAddon.addonCpu.product_pricing[ this.state.billingCycle ] ) } ₫
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="addon-item-cpu">
                                                                {
                                                                    !this.state.special && this.state.addonRam ? (
                                                                        <div className="item">
                                                                            <div className="itemtitle">
                                                                                { this.state.listAddon.addonRam.name }
                                                                            </div>
                                                                            <div className="row">
                                                                                <div className="col col-md-6 item_billing">
                                                                                    { this.state.addonRam  } GB
                                                                                </div>
                                                                                <div className="col col-md-6 item_pricing text-right">
                                                                                    { this.addCommas( this.state.addonRam * this.state.listAddon.addonRam.product_pricing[ this.state.billingCycle ] ) } ₫
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="addon-item-cpu">
                                                                {
                                                                    !this.state.special && this.state.addonDisk ? (
                                                                        <div className="item">
                                                                            <div className="itemtitle">
                                                                                { this.state.listAddon.addonDisk.name }
                                                                            </div>
                                                                            <div className="row">
                                                                                <div className="col col-md-6 item_billing">
                                                                                    { this.state.addonDisk  } GB SSD
                                                                                </div>
                                                                                <div className="col col-md-6 item_pricing text-right">
                                                                                    { this.addCommas( this.state.addonDisk * this.state.listAddon.addonDisk.product_pricing[ this.state.billingCycle ] / 10 ) } ₫
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="order-summary-subtotal">
                                                                <div className="row">
                                                                    <div className="col-md-3">Chi phí</div>
                                                                    <div className="col-md-9 text-right">
                                                                        { this.addCommas( this.state.product.sub_total ) } ₫
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="order-summary-qtt">
                                                                <div className="row">
                                                                    <div className="col-md-3">Số lượng</div>
                                                                    <div className="col-md-9 text-right">{ this.state.qtt }</div>
                                                                </div>
                                                            </div>
                                                            <div className="order-summary-total">
                                                                <div className="row">
                                                                    <div className="col-md-4">Tổng cộng</div>
                                                                    <div className="col-md-8 text-right">{ this.addCommas( this.state.product.sub_total * this.state.qtt ) } ₫</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="button_submit text-center">
                                                            <button type="button" className="btn btn-block btn-primary"
                                                                    disabled={ this.state.btnSubmit }
                                                                    onClick={ () => this.submit() }
                                                            >
                                                                Đặt hàng
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerOrderVpsUs' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderVpsUsComponent);